import axios from '@service'
import { GET_CASH_PAYMENT_RECORD } from './api'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

// 现金缴纳详情
export default async function getCashPaymentRecordService(payload = {}, config = {}) {
    const param = {
        ...GET_CASH_PAYMENT_RECORD,
        ...config,
        params: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
